import { connect } from 'react-redux';
import { saveEmpSurveyAnswers, showEmpLoader } from 'actions/Employee';
import { showOrgSurveyAnswersLoader, handleAnswersMessageClose } from 'actions/OrgSurveyAnswers';
import Component from './Component';


export const mapStateToProps = ({ emps, surveys, settings, surveyGroups, surveyQuestions, orgSurveyAnswers }) => {
    const { width } = settings;
    const { empSurveyAnswers, loader: emploader } = emps;
    const { surveyList } = surveys;
    const { surveyGroupList } = surveyGroups;
    const { surveyQuestionList } = surveyQuestions;
    const { showMessage, alertMessage, loader: answersloader } = orgSurveyAnswers;
    const match = false;

    return {
        width,
        emploader,
        empSurveyAnswers,
        surveyList,
        surveyGroupList,
        surveyQuestionList,
        showMessage,
        alertMessage,
        answersloader,
        match,
    };
};
export default connect(mapStateToProps,
    {
        saveEmpSurveyAnswers,
        showEmpLoader,
        showOrgSurveyAnswersLoader,
        handleAnswersMessageClose,
    })(Component);


// WEBPACK FOOTER //
// ./components/Agile/OrgEmpSurvey/Container.js